























































































































































































import BaseComponent from '@/components/base-component.vue';
import PermissionAuth from '@/components/UI/permission-auth.vue';
import { dateFormat } from '@/helpers/dateFormat';
import { addDays } from '@/helpers/dateUtils';
import { PendenciaPrescricaoFiltroDTO } from '@/interfaces/pending-prescriptions';
import { findPendingPrescriptionsById } from '@/services/pending-prescriptions';
import Component from 'vue-class-component';
import { EmailEditor } from 'vue-email-editor';
import { Prop, Watch } from 'vue-property-decorator';
import UiDatePicker from '../UI/date-picker.vue';
import ListMessages from '../UI/list-messages.vue';
import PendingPrescriptionRegisterModal from './pending-prescription-register-modal.vue';
import PendingPrescriptionStatusChip from './pending-prescription-status-chip.vue';
import PendingPrescriptionTable from './pending-prescription-table.vue';

@Component({
  components: {
    PermissionAuth,
    ListMessages,
    UiDatePicker,
    EmailEditor,
    PendingPrescriptionStatusChip,
    PendingPrescriptionRegisterModal,
    PendingPrescriptionTable
  }
})
export default class PendingPrescriptionForm extends BaseComponent {
  @Prop()
  public isEdit: boolean;
  @Prop()
  public id: number;

  private idShow: number = null;

  public resetForm(): void {}

  currentTab = 0;
  item = null;
  loading = false;
  error = false;

  showRegisterModal = false;

  interval = null;
  mounted() {
    this.interval = setInterval(() => {
      this.load(true);
    }, 60000);
  }

  filtrosMedico = new PendenciaPrescricaoFiltroDTO();
  filtrosTime = new PendenciaPrescricaoFiltroDTO();
  filtrosUnidade = new PendenciaPrescricaoFiltroDTO();
  filtrosPaciente = new PendenciaPrescricaoFiltroDTO();

  beforeDestroy() {
    clearInterval(this.interval);
  }

  private closeAction() {
    this.resetForm();
    this.$emit('close');
  }

  public prescHeaders: any = [
    { text: 'ID', value: 'id', sortable: false },
    { text: 'Entrega', value: 'dataEntrega', sortable: false },
    { text: 'Criado em', value: 'dataEntrega', sortable: false },
    { text: 'Status', value: 'status', sortable: false },
    { text: 'Médico', value: 'medico', sortable: false },
    { text: 'Telefone do médico', value: 'telMedico', sortable: false },
    { text: 'Usuário prescritor', value: 'usuarioCriacao', sortable: false },
    { text: 'Telefone do prescritor', value: 'telUsuario', sortable: false }
  ];

  public histHeaders: any = [
    { text: 'Data', value: 'data', sortable: false },
    { text: 'Usuário', value: 'usuario', sortable: false },
    { text: 'Status', value: 'status', sortable: false },
    { text: 'Justificativa', value: 'justificativa', sortable: false }
  ];

  public closeForm(): void {
    this.closeAction();
  }

  @Watch('id', { immediate: true })
  onIdChange() {
    this.idShow = this.id;
    this.load();
  }

  load(silent = false) {
    this.loading = !silent;
    findPendingPrescriptionsById(this.idShow).subscribe(
      (res) => {
        this.item = res;
        this.loading = false;
        this.error = false;

        this.buildFiltros();
      },
      (error) => {
        this.loading = false;
        this.error = true;
      }
    );
  }

  openRegisterModal() {
    this.showRegisterModal = true;
  }

  onRegisterModalClose() {
    this.showRegisterModal = false;
  }

  onSave() {
    this.load(true);
    this.$emit('refresh');
    this.onRegisterModalClose();

    this.dialog.show(
      'alert',
      'Sucesso',
      'Registro salvo com sucesso.',
      'Fechar',
      () => {
        this.closeForm();
      },
      'Continuar',
      () => {}
    );
  }

  buildFiltros() {
    if (!this.item) {
      return;
    }
    let filtros = new PendenciaPrescricaoFiltroDTO();
    filtros.dataDe = this.item.dataIso;
    filtros.dataAte = this.item.dataIso;

    this.filtrosMedico = Object.assign(new PendenciaPrescricaoFiltroDTO(), filtros);
    this.filtrosTime = Object.assign(new PendenciaPrescricaoFiltroDTO(), filtros);
    this.filtrosUnidade = Object.assign(new PendenciaPrescricaoFiltroDTO(), filtros);
    this.filtrosPaciente = Object.assign(new PendenciaPrescricaoFiltroDTO(), filtros);

    this.filtrosMedico.idMedico = this.item.idMedico;
    
    this.filtrosTime.idMedico = this.item.idMedico;
    this.filtrosTime.time = true;

    this.filtrosUnidade.idUnidade = this.item.idUnidade;
    
    this.filtrosPaciente.idPaciente = this.item.idPaciente;
    this.filtrosPaciente.dataDe = dateFormat(addDays(new Date(), -30).toISOString(), 'ISO-DATE');
    this.filtrosPaciente.dataAte = dateFormat(new Date().toISOString(), 'ISO-DATE');
    this.filtrosPaciente.sortProperties = 'dataPendencia';
    this.filtrosPaciente.direction = 'DESC';
  }

  qtdePendMedico = '';
  showBadgeMedico = false;
  onListChangeMedico(pag) {
    let q = this.getQtdePendentesLista(pag.content);
    if (q > 9) {
      this.qtdePendMedico = '9+';
    } else {
      this.qtdePendMedico = new String(q).toString();
    }
    this.showBadgeMedico = q > 0;
  }

  qtdePendTime = '';
  showBadgeTime = false;
  onListChangeTime(pag) {
    let q = this.getQtdePendentesLista(pag.content);
    if (q > 9) {
      this.qtdePendTime = '9+';
    } else {
      this.qtdePendTime = new String(q).toString();
    }
    this.showBadgeTime = q > 0;
  }

  qtdePendUnidade = '';
  showBadgeUnidade = false;
  onListChangeUnidade(pag) {
    let q = this.getQtdePendentesLista(pag.content);
    if (q > 9) {
      this.qtdePendUnidade = '9+';
    } else {
      this.qtdePendUnidade = new String(q).toString();
    }
    this.showBadgeUnidade = q > 0;
  }

  getQtdePendentesLista(list) {
    return list.filter((p) => !p.finalizada && !p.solucionada).length;
  }

  onIdChangeTable(id) {
    this.idShow = id;
    this.currentTab = 0;
    this.load();
  }
}
